import styles from "./CostBreakdownSummary.module.css";

const CostBreakdownSummary = ({ data }) => {
    if (!data) {
        return null;
    }

    const {
        totalCost,
        currency,
        changePercentage,
        items = [],
    } = data;

    return (
        <section
            className={styles.card}
            dir="rtl"
        >
            <div className={styles.header}>
                <div>
                    <span className={styles.eyebrow}>
                        گزارش خلاصه هزینه
                    </span>

                    <h2>
                        تفکیک هزینه‌ها
                    </h2>
                </div>

                <span className={styles.badge}>
                    هزینه
                </span>
            </div>

            <div className={styles.totalRow}>
                <div>
                    <span className={styles.label}>
                        کل هزینه
                    </span>

                    <strong className={styles.total}>
                        {Number(
                            totalCost || 0
                        ).toLocaleString("fa-IR")}
                    </strong>

                    <small>
                        {currency}
                    </small>
                </div>

                <div className={styles.change}>
                    <span>
                        نسبت به دوره قبل
                    </span>

                    <strong>
                        {changePercentage > 0
                            ? `+${changePercentage}%`
                            : `${changePercentage}%`}
                    </strong>
                </div>
            </div>

            <div className={styles.items}>
                {items
                    .filter(
                        (item) =>
                            Number(item.percentage) > 0
                    )
                    .map((item) => (
                        <div
                            key={item.key}
                            className={styles.item}
                        >
                            <div className={styles.itemInfo}>
                                <span className={styles.dot} />

                                <span>
                                    {item.label}
                                </span>
                            </div>

                            <div className={styles.itemValue}>
                                <strong>
                                    {Number(
                                        item.amount || 0
                                    ).toLocaleString(
                                        "fa-IR"
                                    )}
                                </strong>

                                <span>
                                    {Number(
                                        item.percentage || 0
                                    ).toLocaleString(
                                        "fa-IR"
                                    )}%
                                    {/* {item.percentage}% */}
                                </span>
                            </div>
                        </div>
                    ))}
            </div>
        </section>
    );
};

export default CostBreakdownSummary;